import type { Product } from '../data/products'
import './ProductCard.css'

export type { Product } from '../data/products'

export default function ProductCard({ category, description, imageSrc, item, title }: Product) {
  return (
    <article className="product-card overflow-hidden rounded-lg">
      <div className="relative">
        <img src={imageSrc} alt={title} className="product-card__image aspect-[1.75] w-full object-cover" />
        <button type="button" aria-label={`Save ${title}`} className="product-card__save absolute right-3 top-3 grid h-8 w-8 place-items-center rounded-full text-xl font-bold shadow">♡</button>
      </div>
      <div className="product-card__body flex min-h-[264px] flex-col px-4 py-3">
        <span className="product-card__category self-start px-2 py-1 text-[10px] font-extrabold uppercase">{category}</span>
        <h2 className="product-card__title mt-3">{title}</h2>
        <p className="product-card__item">Item nr: {item}</p>
        <p className="product-card__description mt-3">{description}</p>
        <div className="mt-auto grid grid-cols-3 gap-2 pt-4 text-[10px]">
          <span><small className="product-card__spec-label block">Thickness</small>30-200 mm</span>
          <span><small className="product-card__spec-label block">Width</small>1000 mm</span>
          <span><small className="product-card__spec-label block">Core</small>PIR</span>
        </div>
        <div className="mt-3 flex items-end justify-between gap-2">
          <div><p className="product-card__price text-sm font-extrabold">Prices MP</p><p className="product-card__stock text-xs">● In stock</p></div>
          <button type="button" className="product-card__quote h-9 px-4 text-xs font-extrabold text-white">ADD TO QUOTE</button>
        </div>
      </div>
    </article>
  )
}
